'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { SERVER_REGION } from '../../i18n';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  // if the server region is not CN, do not display the language switcher
  if (SERVER_REGION !== 'CN') {
    return null;
  }

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center space-x-2">
      <button 
        onClick={() => changeLanguage('en')} 
        className={`px-3 py-1 text-sm font-medium rounded transition-colors cursor-pointer ${
          i18n.language === 'en' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-200 text-gray-900 hover:bg-gray-300'
        }`}
      >
        English
      </button>
      <button 
        onClick={() => changeLanguage('zh')} 
        className={`px-3 py-1 text-sm font-medium rounded transition-colors cursor-pointer ${
          i18n.language === 'zh' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-200 text-gray-900 hover:bg-gray-300'
        }`}
      >
        中文
      </button>
    </div>
  );
};

export default LanguageSwitcher;



